import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Login from "./layouts/login";
import Profile from "./layouts/profile";
import MyRequests from "./layouts/requests";
import Support from "./layouts/support";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ErrorPage from "./error-page";
import Error404Page from "./404-page";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "conversations",
        element: <App />,
        children: [
          {
            path: ":id",
            element: <App />,
          },
        ],
      },
    ],
  },
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "profile",
    element: <Profile />,
  },
  {
    path: "requests",
    element: <MyRequests />,
  },
  {
    // Customer support inbox (Logi live agent); gated to cs_access users inside.
    path: "support",
    element: <Support />,
  },
  {
    path: "not-found",
    element: <Error404Page />,
  },
]);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();
